import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AlgoliaApp } from './Algolia.App';
import { createRoot } from 'react-dom/client';
const container = document.querySelector('.alg-app');
if (container !== null) {
    const appRouter = createBrowserRouter([
        {
            path: '/collections/:handle',
            element: React.createElement(AlgoliaApp, { pagePath: 'collections' }),
            children: [
                { path: ':medium' }
            ]
        },
        {
            path: '/pages/topic',
            element: React.createElement(AlgoliaApp, { pagePath: 'search' }),
            children: [
                { path: ':medium' }
            ]
        },
        {
            path: '/pages/tags',
            element: React.createElement(AlgoliaApp, { pagePath: 'search' }),
            children: [
                { path: ':medium' }
            ]
        },
        {
            path: '/pages/query',
            element: React.createElement(AlgoliaApp, { pagePath: 'search' }),
            children: [
                { path: ':medium' }
            ]
        },
        {
            path: '/search',
            element: React.createElement(AlgoliaApp, { pagePath: 'search' })
        }
    ]);
    const root = createRoot(container);
    root.render(React.createElement(RouterProvider, { router: appRouter }));
}
